
import React, { useEffect } from "react";
import { Message as UIMessage } from "@/types/message";
import { Conversation } from "@/types/conversation";
import { DBMessage } from "@/types/message";
import InitialResponseGenerator from "./InitialResponseGenerator";
import SellerResponseSection from "./SellerResponseSection";
import type { ClarificationType } from "../ClarificationInput";

interface ConversationActionsProps {
  isAnyLoading: boolean;
  hasAIMessages: boolean;
  messages: UIMessage[];
  onGenerateInitialResponse: () => Promise<void>;
  onPasteSellerResponse: (content: string) => void;
  isPasting: boolean;
  isProcessingAI: boolean;
  latestAIMessage?: UIMessage | null;
  conversation?: Conversation;
  dbMessages?: DBMessage[];
  onClarificationSubmit?: (clarification: string, type: ClarificationType) => void;
  onGenerateFollowUp?: (type: string) => void;
  isClarificationSubmitting?: boolean;
}

const ConversationActions = ({
  isAnyLoading,
  hasAIMessages,
  messages,
  onGenerateInitialResponse,
  onPasteSellerResponse,
  isPasting,
  isProcessingAI,
  latestAIMessage,
  conversation,
  dbMessages = [],
  onClarificationSubmit,
  onGenerateFollowUp,
  isClarificationSubmitting = false
}: ConversationActionsProps) => {
  // Auto-generate initial response when conversation loads without AI messages
  useEffect(() => {
    if (conversation && !hasAIMessages && !isAnyLoading && messages.length > 0) {
      // Only auto-generate for new conversations that have user messages but no AI responses
      const hasUserMessages = messages.some(msg => msg.type === 'user');
      if (hasUserMessages) {
        onGenerateInitialResponse();
      }
    }
  }, [conversation, hasAIMessages, isAnyLoading, messages, onGenerateInitialResponse]);

  const isFlightClaim = conversation?.request_type === "flight_compensation";

  return (
    <div className="space-y-4">
      {!hasAIMessages && !isFlightClaim && (
        <InitialResponseGenerator 
          onGenerate={onGenerateInitialResponse}
          isGenerating={isAnyLoading}
        />
      )}
      
      {hasAIMessages && (
        <SellerResponseSection
          onPasteSellerResponse={onPasteSellerResponse}
          isPasting={isPasting}
          isProcessingAI={isProcessingAI}
          hasMessages={messages.length > 0}
          lastAIMessage={latestAIMessage}
          isFlightClaim={isFlightClaim}
        />
      )}
    </div>
  );
};

export default ConversationActions;
